module.exports = __webpack_public_path__ + "img/bg4s.43a7385d.png";